import apiUrl from '../../../../constants';
import axios from 'axios';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment';

export default {
  name: 'bag-in-shipment-live-response',
  components: { VueElementLoading },
  props: ['KENGIC_API_KEY', 'hubid'],
  data() {
    return {
      isLoading: false,
      sublist: false,
      isShippingIdError: 0,
      ShippingIdError: '',
      shippingId: '',
      createdAt: '',
      createdBy: '',
      ShipmentDetails: [],
      ShipmentResponseData: []
    }
  },
  computed: {},
  filters: {
    moment: function (date) {
      if (date == '' || date == null) {
        return '--'
      }
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    }
  },
  mounted() { },
  methods: {
    getShipmentDetails() {
      this.ShipmentDetails = []
      this.ShipmentResponseData = []
      this.createdAt = ''
      if (this.shippingId == '') {
        this.isShippingIdError = '1';
        this.ShippingIdError = 'The Shipping Id field is required.';
        return false;
      } else {
        this.isShippingIdError = '';
        this.ShippingIdError = '';
      }
      this.isLoading = true
      this.input = ({})
      axios({
        method: 'GET',
        'url': apiUrl.api_url_hubops + 'getKengicApiResponseForSorterShipment?shippingId=' + this.shippingId.trim() + '&currentHubId=' + this.hubid,
        'data': this.input,
        headers: {
          'Authorization': this.KENGIC_API_KEY
        }
      })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.isLoading = false
            this.sublist = true
            for (const element of result.data.ResponseData) {
              this.ShipmentDetails.push(element.Request)
              this.ShipmentResponseData.push(element)
              this.createdAt = element.CreatedDate
            }
          } else {
            this.$alertify.error(result.data.ReturnMessage)
            this.isLoading = false
          }
        }, error => {
          this.isLoading = false
          console.error(error)
        })
    },
    clearError() {
      if (this.shippingId == '') {
        this.isShippingIdError = '1';
        this.ShippingIdError = 'The Shipping Id field is required.';
      } else {
        this.isShippingIdError = '';
        this.ShippingIdError = '';
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/KengicSorter/ApiResponseLog/ApiResponseLog.js